import React from 'react';
import './NotFound.css';

const NotFound = () => {
    return (
        <div className="text-danger notFound">
            
            <img 
            src="https://i.ibb.co/BnyQKNK/3747371.jpg"
            className="img-fluid"
            alt="" />
        </div>
    );
};

export default NotFound;